import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { ThemeProvider } from "styled-components";
import { ToastContainer } from "react-toastify";
import { Provider } from 'react-redux';

import theme from 'styles/theme';
import { store } from "../store";
import { AuthProvider } from 'hooks/authHook';
import { TourProvider } from 'hooks/useTour';
import { MFAContextProvider } from 'hooks/useMFA';
import { AddNewUnitProvider } from 'pages/AddNewUnit/hooks/useAddNewUnit';
import { QuickBillProvider } from 'pages/BoletoRapido/hooks/useQuickBill';

const AppProviders = ({ children }) => (
  <Provider store={store}>
    <QuickBillProvider>
      <AuthProvider>
        <MFAContextProvider>
        <TourProvider>
          <AddNewUnitProvider>
          <ThemeProvider theme={theme}>
            <CookiesProvider>
              <ToastContainer
                  position="top-right"
                  autoClose={10000}
                  hideProgressBar={false}
                  rtl={false}
                  newestOnTop
                  closeOnClick
                  pauseOnVisibilityChange
                  draggable
                  pauseOnHover
              />
              {children}
            </CookiesProvider>
          </ThemeProvider>
          </AddNewUnitProvider>
        </TourProvider>
        </MFAContextProvider>
      </AuthProvider>
    </QuickBillProvider>
  </Provider>
)

export default AppProviders;
